export default __webpack_public_path__ + "static/media/facebookDesk.2270d090.svg";